export const GET_APP_BASE = 'GET_APP_BASE'
// 图标及启动页
export const GET_APP_ICON = 'GET_APP_ICON'
export const SET_APP_ICON = 'SET_APP_ICON'
export const SET_APP_SPLASH = 'SET_APP_SPLASH'
export const SET_SPLASH_ITEM = 'SET_SPLASH_ITEM'

// cordova 配置文件
export const SET_CORDOVA_CONFIG = 'SET_CORDOVA_CONFIG'
export const GET_CORDOVA_CONFIG = 'GET_CORDOVA_CONFIG'

// 证书
export const GET_IOS_CRED = 'GET_IOS_CRED'
export const SET_IOS_CRED = 'SET_IOS_CRED'
export const RESET_IOS_CRED = 'RESET_IOS_CRED'
export const SET_IOS_PROFILE = 'SET_IOS_PROFILE'
export const SET_IOS_CRED_TYPE = 'SET_IOS_CRED_TYPE'
export const GET_ANDROID_CRED = 'GET_ANDROID_CRED'
export const SET_ANDROID_CRED = 'SET_ANDROID_CRED'
export const RESET_ANDROID_CRED = 'RESET_ANDROID_CRED'

// 引擎
export const GET_ENGINE_LSIT = 'GET_ENGINE_LIST'
export const SET_ENGINE_LSIT = 'SET_ENGINE_LIST'
export const SET_CURRENT_ENGINE = 'SET_CURRENT_ENGINE'

// hooks
export const GET_HOOKS = 'GET_HOOKS'
export const SET_HOOKS = 'SET_HOOKS'
export const ADD_HOOK = 'ADD_HOOK'
export const DELETE_HOOK = 'DELETE_HOOK'
export const DOWNLOAD_HOOK = 'DOWNLOAD_HOOK'

// plugin
export const GET_PLUGIN_LIST = 'GET_PLUGIN_LIST'
export const SET_PLUGIN_LIST = 'SET_PLUGIN_LIST'
export const RESET_PLUGIN_LIST = 'RESET_PLUGIN_LIST'
export const GET_PLUGIN_LOG = 'GET_PLUGIN_LOG'
export const GET_PLUGIN_PARAMS = 'GET_PLUGIN_PARAMS'
export const UPDATE_PLUGIN = 'UPDATE_PLUGIN'
export const GET_PLUGIN_STATUS = 'GET_PLUGIN_STATUS'
export const SET_PLUGIN_STATUS = 'SET_PLUGIN_STATUS'

// build
export const CREATE_PACKAGE = 'CREATE_PACKAGE'
export const GET_PACKAGE_LIST = 'GET_PACKAGE_LIST'
export const SET_PACKAGE_LIST = 'SET_PACKAGE_LIST'
export const SET_APP_VERSION = 'SET_APP_VERSION'
export const RESET_PACKAGE_LIST = 'RESET_PACKAGE_LIST'
export const GET_QRCODE = 'GET_QRCODE'
export const RE_PACKAGE = 'RE_PACKAGE'
export const UPLOAD_APP = 'UPLOAD_APP'
